import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ApiCompatibilityService} from '../api/api-compatibility.service';
import {SmConfirmationDialogModule} from '../components/sm-confirmation-dialog/sm-confirmation-dialog.module';
import {ExternalBrowserService} from '../external-browser.service';
import {WebVersionHintService} from './web-version-hint.service';

@Component({
  selector: 'sm-web-version-hint',
  templateUrl: './web-version-hint.component.html',
  styleUrls: ['./web-version-hint.component.scss'],
  imports: [TranslateModule, SmConfirmationDialogModule],
})
export class WebVersionHintComponent implements OnInit, OnDestroy {
  @Input() blocked = false;

  constructor(readonly hint: WebVersionHintService, private readonly compatibility: ApiCompatibilityService,
    private readonly browser: ExternalBrowserService) {}

  get isOpen(): boolean {
    return this.hint.pending() && !this.blocked && !this.compatibility.recoveryVisible()
      && (!this.compatibility.active() || this.compatibility.state() === 'compatible');
  }

  ngOnInit(): void {
    void this.hint.initialize();
  }

  ngOnDestroy(): void {
    this.hint.destroy();
  }

  async openWebVersion(event: Event): Promise<void> {
    event.preventDefault();
    if (this.isOpen) await this.browser.open('https://invemory.com');
  }
}
